// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__3mKkp","popup-container":"classes_popup-container__3UlIo","text":"classes_text__20aDP","content":"classes_content__sT_0q"};